<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <!-- <el-form-item label="项目名称:">
                <el-input size="small" v-model="dataForm.projectName" placeholder="项目名称" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
          <el-form-item label="子公司" prop="subcompanyIdList">
            <el-select multiple  v-model="dataForm.subcompanyIdList"
                       @change="getSupCompanyList"
                       filterable
                       clearable
                       popper-class="fixed-dropdown"
                       collapse-tags
                       class="input-width">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="询价单编码:">
                <el-input size="small" v-model="dataForm.rfqCode" placeholder="询价单编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <!-- 询价开始 询价中 询价结束 -->
            <el-form-item label="询价单状态:">
                <el-select v-model="dataForm.rfqStatusList" placeholder="请选择" clearable multiple @change="getDataList" size="small">
                    <el-option v-for="item in rfqStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item label="询价单类型:">
                <el-select v-model="dataForm.rfqType" placeholder="请选择" clearable @change="getDataList" size="small">
                    <el-option v-for="item in RFQ_TYPE_VALUE" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item label="任务编码:">
                <el-input size="small" v-model="dataForm.taskCode" placeholder="任务编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
          <el-form-item label="采购工程师" prop="engineerIds">
            <el-select multiple  v-model="dataForm.engineerIds" @change="getListEngineer" class="input-width">
              <el-option
                  v-for="item in processedEngineerList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sourcing:rfq:newRfq')" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建询价单
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    导入询价单
                </el-button> -->
                <el-button size="small" type="primary" @click="mpAddOrUpdateHandle()">
                    新增量产定价
                </el-button>
                <el-button size="small" type="primary" @click="sbAddOrUpdateHandle()">
                    新增设变定价
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bRFQ style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}" :default-expand-all="false" border :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="rfqCode" header-align="center" align="left" label="询价单编码" width="145">
                </el-table-column>
                <el-table-column prop="rfqName" header-align="center" align="left" label="询价单名称" width="200">
                </el-table-column>
                <el-table-column prop="taskCode" header-align="center" align="left" label="任务编码" width="150">
                </el-table-column>
                <!-- <el-table-column prop="taskName" header-align="center" align="left" label="任务名称">
                </el-table-column> -->
                <el-table-column prop="times" header-align="center" align="center" label="轮次" width="50">
                </el-table-column>
                <el-table-column prop="delayTimes" header-align="center" align="center" label="延期次数" width="70">
                </el-table-column>
                <el-table-column prop="quotationStopTime" header-align="center" align="right" label="报价截止日期" :formatter="dateFormat" width="140">
                </el-table-column>
                <el-table-column prop="priceBit" header-align="center" align="center" label="价格位数" width="70">
                </el-table-column>
                <el-table-column prop="rfqStatus" header-align="center" align="center" label="状态" width="80">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.rfqStatus)">
                            {{rfqStatusFormat(scope.row.rfqStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="rfqType" header-align="center" align="right" label="询价类型" width="80">
                    <template slot-scope="scope">
                        <span>
                            {{rfqTypeFormat(scope.row.rfqType)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="sourceType" header-align="center" align="center" label="招标类型" width="80">
                    <template slot-scope="scope">
                        <span>
                            {{sourceTypeFormat(scope.row.sourceType)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="supplyEngineer" header-align="center" align="center" label="采购工程师" width="100">
                </el-table-column>
                <!-- <el-table-column prop="quotationStatus" header-align="center" align="center" label="报价状态" width="80">
                <template slot-scope="scope">
                    <span :class="getStatusClass(scope.row.quotationStatus)">
                        {{quotationStatusFormat(scope.row.quotationStatus)}}
                    </span>
                </template>
            </el-table-column> -->
                <!-- <el-table-column prop="createTime" header-align="center" align="left" label="创建时间" :formatter="dateFormat"> -->
                <el-table-column prop="rfqCreateTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="140">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="190" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit" :disabled="isUpdated(scope.row.supplyEngineer)">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="downLoadZipFile(scope.row)" icon="el-icon-edit">
                          下载
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger"
                            :disabled="isDisabled(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="fixed-pagination"
                           @size-change="sizeChangeHandle"
                           @current-change="currentChangeHandle"
                           :current-page="pageIndex"
                           :page-sizes="[10, 20, 50]"
                           :page-size="pageSize"
                           :total="totalPage"
                           layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" @close="addOrUpdateVisible = false"></add-or-update>
        <!-- 弹窗, 新增 / 修改 量产定价 -->
        <mp-add-or-update v-if="mpAddOrUpdateVisible" ref="mpAddOrUpdate" @refreshDataList="getDataList" @close="mpAddOrUpdateVisible = false"></mp-add-or-update>
        <!-- <add-or-update-q v-if="addOrUpdateQVisible" ref="addOrUpdateQ" @refreshDataList="getDataList"></add-or-update-q> -->
        <!-- <RfqDialog ref="rfqDialog" @refreshDataList="getDataList" /> -->
        <sb-add-or-update v-if="sbAddOrUpdateVisible" ref="sbAddOrUpdate" @refreshDataList="getDataList" @close="sbAddOrUpdateVisible = false"></sb-add-or-update>
    </div>
</div>
</template>

<script>
import {
    fetchRFQList,
    deleteRFQ,
    downLoadZipFile
} from '@/controller/rfq'
import AddOrUpdate from './rfq-add-or-update'
import MpAddOrUpdate from './mprfq-add-or-update'
import SbAddOrUpdate from './sbrfq-add-or-update'
// import AddOrUpdateQ from './rfq-quotation-add-or-update'
// import RfqDialog from './rfq-dialog'
import moment from 'moment'
import {
    RFQ_STATUS,
    RFQ_STATUS_VALUE,
    QUOTATION_STATUS_VALUE,
    getRFQ_STATUS_VALUE,
    getLabelByValue,
    RFQ_TYPE_VALUE,
    SOURCE_TYPE_VALUE
} from '@/utils/const'
import {getUserInfoByToken} from '@/controller/sys'
import {supCompanyList} from "../../../../controller/sys";
import {listEngineer} from "../../../../controller/rfq";
// require('@/mock/mockRFQ');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                rfqCode: '',
                projectName: '',
                rfqStatusList: ['0', '1', '2', '3', '4'],
                rfqType: '',
                taskCode: '',
                subcompanyIdList:[],
                engineerIds:[],
            },
            RFQ_STATUS: RFQ_STATUS,
            RFQ_STATUS_VALUE: RFQ_STATUS_VALUE,
            rfqStatusOptions: RFQ_STATUS_VALUE,
            getLabelByValue: getLabelByValue,
            getRFQ_STATUS_VALUE: getRFQ_STATUS_VALUE,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            RFQ_TYPE_VALUE: RFQ_TYPE_VALUE,
            mpAddOrUpdateVisible: false,
            sbAddOrUpdateVisible: false,
            userRealName: '',
            plmTechCount: 0,
            listEngineerList:[],
            processedEngineerList: [],
            supCompanyList: [],
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 260
            }
        }
    },
    components: {
        AddOrUpdate,
        MpAddOrUpdate,
        SbAddOrUpdate
    },
    activated() {
        //this.getDataList()
        this.getUserInfo()
        this.getListEngineer()
        this.getDataList()
    },
    methods: {
      downLoadZipFile(row) {
        this.$message.info('正在准备下载文件，请稍候...');
        downLoadZipFile({ rfqCode: row.rfqCode })
            .then(response => {
              console.log('下载响应对象:', response); // 👈 打印整个 response 对象
              console.log('response.data:', response.data);
              console.log('response.data 类型:', typeof response.data);

              // 检查响应状态
              if (response.status !== 200) {
                this.$message.error('文件下载失败或寻源文件为空');
                return;
              }

              if (!response.data) {
                this.$message.error('下载的文件内容为空');
                return;
              }

              // 创建 Blob 对象
              const blob = new Blob([response.data], { type: 'application/zip' });

              // 检查 Blob 是否有效
              if (blob.size === 0) {
                this.$message.error('创建的文件内容为空');
                return;
              }

              // 创建下载链接
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;

              // 设置下载文件名
              const fileName = `${row.rfqCode}-寻源文件.zip`;
              link.setAttribute('download', fileName);

              // 触发下载
              document.body.appendChild(link);
              link.click();

              // 清理
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);

              this.$message.success('文件下载成功');
            })
            .catch(error => {
              console.error('下载失败:', error);
              this.$message.error('文件下载失败: ' + (error.message || '未知错误'));
            });
      },
      dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        rfqStatusFormat: function (value) {
            value = String(value)
            if (!value) {
                return ''
            }
            return getLabelByValue(RFQ_STATUS_VALUE, value)
        },
        quotationStatusFormat: function (value) {
            value = String(value)
            if (!value) {
                return ''
            }
            return getLabelByValue(QUOTATION_STATUS_VALUE, value)
        },
        rfqTypeFormat: function (value) {
            value = String(value)
            if (!value) {
                return ''
            }
            return getLabelByValue(RFQ_TYPE_VALUE, value)
        },
        sourceTypeFormat: function (value) {
            value = String(value)
            if (!value) {
                return ''
            }
            return getLabelByValue(SOURCE_TYPE_VALUE, value)
        },
        // // 新增或编辑子节点
        // addChildHandle(id, parentId, parentName, parentNodePath) {

        //     console.log(id, parentId, parentName, parentNodePath)
        //     this.addOrUpdateVisible = true
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
        //     })
        // },
        // 获取当前登录人员信息
        getUserInfo() {
            getUserInfoByToken({}).then(data => {
                if (data && data.code === '00') {
                    //this.dataForm.projectManagerName = data.body.user.realName
                    this.userRealName = data.body.user.realName
                    this.getSupCompanyList(); // 先加载子公司列表

                }
            })
        },
        isUpdated(val) {
            if(val === this.userRealName) {
                return false
            } else {
                return true
            }
        },
        isDisabled(row) {
            //console.log("row==="+row.technicalCode)
            if(row.supplyEngineer === this.userRealName) {
                if(row.rfqType == '2' || row.rfqType == '3') {
                    if(row.rfqStatus === RFQ_STATUS.BEGIN) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    let arr = ["0","1","2","3"];
                    if(row.deleteRfqFlag && arr.indexOf(row.rfqStatus) > -1) {
                        return false
                    } else {
                        return true
                    }
                }
            } else {
                return true
            }
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchRFQList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                totalPage: this.totalPage,
                ...this.dataForm
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                  if (this.listEngineerList.length > 0) {
                    this.updateProcessedEngineerList();
                  }
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
      //获取子公司列表
      getSupCompanyList(){
        supCompanyList().then(res=>{
          if(res && res.code == '00'){
            this.supCompanyList = res.body;
            // 若未选择子公司，则默认选中所有/第一个子公司
            if (!this.dataForm.subcompanyIdList.length) {
              this.dataForm.subcompanyIdList = res.body.map(item => item.id); // 默认全选
              // 或者只选第一个：this.dataForm.subcompanyIdList = [res.body[0]?.id];
            }
            this.getDataList();
          }
        })
      },
      getListEngineer(){
        listEngineer().then(res=>{
          if(res && res.code == '00'){
            this.listEngineerList = res.body;
            if (this.dataList && this.dataList.length > 0) {
              this.updateProcessedEngineerList();
            }
          }
        })
      },
      updateProcessedEngineerList() {
        // 创建工程师ID到姓名的映射
        const engineerMap = new Map();

        // 遍历当前数据列表，收集所有唯一的工程师ID和姓名
        this.dataList.forEach(row => {
          if (row.supplyEngineerId && (row.supplyEngineer || row.supplyResponsor)) {
            const engineerName = row.supplyEngineer || row.supplyResponsor;
            engineerMap.set(row.supplyEngineerId, engineerName);
          }
        });

        // 构建处理后的工程师列表
        this.processedEngineerList = this.listEngineerList.map(item => {
          const engineerName = engineerMap.get(item.value) || item.code;
          return {
            id: item.value, // 使用接口返回的value作为id（对应supplyEngineerId）
            name: engineerName // 显示工程师姓名，如果找不到则显示code
          };
        });
      },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            // if (row && row.rfqStatus === RFQ_STATUS.RFQEND) {
            //     this.addOrUpdateQVisible = true
            //     this.$nextTick(() => {
            //         // this.$refs.addOrUpdateQ.init(row, row ? row.id : 0, true, 0, null, null, null)
            //     })
            // } else {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : 0, true, 0, null, null, null)
            })
            // }
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            console.log(row)
            // if (row && row.rfqStatus === RFQ_STATUS.RFQEND) {
            //     this.addOrUpdateQVisible = true
            //     this.$nextTick(() => {
            //         // this.$refs.addOrUpdateQ.init(row, row ? row.id : 0, false, 0, null, null, null)
            //     })
            // } else {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : 0, false, 0, null, null, null)
            })

            // this.$refs.RfqDialog.open()
            // }
        },
        // 删除
        deleteHandle(id) {
            console.log(id)
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteRFQ({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 量产定价 新增 / 修改
        mpAddOrUpdateHandle() {
            this.mpAddOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.mpAddOrUpdate.init()
            })
        },
        // 设变定价 新增 / 修改
        sbAddOrUpdateHandle() {
            this.sbAddOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.sbAddOrUpdate.init()
            })
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                case '6b':
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        }
    }
}
</script>
<style lang="scss" scoped>
:deep(.fixed-dropdown) {
  position: fixed !important;
  z-index: 9999 !important;

  /* 修复多选标签高度问题 */
  .el-select-dropdown__list {
    max-height: 300px;
    overflow-y: auto;
  }
}
.fixed-dropdown {
  position: fixed !important;
  z-index: 9999 !important;
}
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: white;
  padding: 10px 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
</style>